export enum AssetTransactionType {
  Sale = 'sale',
  Rental = 'rental',
}
